import Skeleton from 'react-loading-skeleton';
import cx from 'classnames';
import { TableSkeleton } from '../table';

import s from './styles.module.scss';
import 'react-loading-skeleton/dist/skeleton.css';

interface DetailsPageSkeletonProps {
  showTableSkeleton?: boolean;
}

export const DetailsPageSkeleton = ({ showTableSkeleton = true }: DetailsPageSkeletonProps) => {
  return (
    <div className={s.skeleton}>
      <div className={cx(s.skeletonContent, s.skeletonContentSpaceBetween)}>
        <div className={s.skeletonFlex}>
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
        </div>

        <Skeleton height={35} width={150} />
      </div>

      <div className={s.skeletonContent}>
        <div className={s.skeletonContentSection}>
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
        </div>

        <div className={s.skeletonContentSection}>
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
        </div>

        <div className={s.skeletonContentSection}>
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
        </div>
      </div>

      <div className={s.skeletonContent}>
        <div className={s.skeletonContentSection}>
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
        </div>

        <div className={s.skeletonContentSection}>
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
        </div>

        <div className={s.skeletonContentSection}>
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
          <Skeleton height={35} width={150} />
        </div>
      </div>

      {showTableSkeleton && (
        <>
          <div className={s.skeletonContentSpaceBetween}>
            <Skeleton height={35} width={150} />

            <Skeleton height={40} width={150} />
          </div>

          <TableSkeleton />
        </>
      )}
    </div>
  );
};
